<template>
    <a-layout id="ai-layout">
        <a-layout-header id="ai-header">
            <img class="ai_head_img1" src="../../assets/ai_head_title.png">
            <span>微软AI</span>
        </a-layout-header>
        <a-layout-content id="ai-content">
            <component :is="item.component" :text="item.text" v-for="(item,index) in items" :key="index"></component>
        </a-layout-content>
        <a-layout-footer id="ai-footer">
            <a-input class="ai_input" v-model:value="input" :placeholder="$t('message')['IwownAi.hint']" @keyup.enter.native="userSend()"></a-input>
            <a-button class="primaryBtn" @click="userSend()">{{ $t("message")["IwownAi.send"] }}</a-button>
        </a-layout-footer>
    </a-layout>
</template>

<script>
// eslint-disable-line
import talkAnswer from "./AiAnswer.vue";
// eslint-disable-line
import talkAsker from "./UserAsk.vue";
import request from "../../utils/request";
export default {
  components: {
    talkAnswer, // eslint-disable-line
    talkAsker, // eslint-disable-line
  },
  data() {
    return {
      input: "",
      testNum: 0,
      items: [
          {component:"talkAnswer",text:this.$t('message')['IwownAi.aislogan']}
      ],
      userInput:"",
    };
  },
  mounted() {
    console.log(document.documentElement.clientWidth)
  },
  methods: {
    userSend() {
        if(this.input==""){
            console.log('no input');
            return;
        }
        this.testNum++;
        var askerMsg = {component:"talkAsker",text:this.input}
        this.items.push(askerMsg);
        //var answerMsg = {component:"talkAnswer",text:"哎呀，我还处在开发当中。。。"};
        //this.items.push(answerMsg);
        let that = this
        request({
          url: "https://api1.iwown.com/venus/ai_access/chat",
          method: "POST",
          data: {
            query: this.input
          }
        })
        .then(function(response) {
          if (response != null) {
            let sd = response.data.data;
            var answerMsg = {component:"talkAnswer",text:sd};
            that.items.push(answerMsg);
          }
        })
        .catch(function(error) {
          if (error != null) {
            console.log(error);
          }
          let answerMsg = {component:"talkAnswer",text:that.$t('message')['IwownAi.aifailed']};
          that.items.push(answerMsg);
        });
        console.log('finish request');
        this.input="";
    }
  }
};
</script>

<style scoped lang="scss">
#ai-layout {
  flex: 1;
  border-radius: 5px;
}

#ai-header {
  line-height: 64px;
  display: flex;
  font-size: 16px;
  color: #52ba9f;
  background-color: #ffffff;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  padding-inline: 10px;
}

.ai_head_img1 {
  width: 24px;
  height: 24px;
}

.primaryBtn {
  background-color: #65c294;
  color: #ffffff; 
}

.ai_input {
  width: 85%;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  text-align: left;
  line-height: 14px;
  box-shadow: 0px 0px 0px 0px white;
  margin-right: 5px;
}

#ai-content {
  background-color: #ffffff;
}

#ai-footer {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  background-color: #ffffff;
  padding-inline: 10px;
}
</style>